import React, {FC} from 'react';
import {Icon} from '../Icon';
import {ViewUserCouponDto} from "../../types/types";

interface CouponPopUpProps {
    open: boolean;
    coupons: ViewUserCouponDto[];
    selectedCouponIds: number[];
    onClose: () => void;
    onSelect: (couponId: number) => void;
}

export const CouponPopUp: FC<CouponPopUpProps> = (props) => {
    const {onClose, open, coupons, onSelect, selectedCouponIds} = props;
    if (!open) return <></>;

    return (
        <>
            <div className="z-50 fixed inset-0 bg-littleblack flex items-center justify-center px-4 ">
                <div className=" w-96 flex flex-col  bg-white p-6 space-y-4 overflow-y-auto">
                    <div className="flex flex-row justify-between ">
                        <p className="text-18 font-medium">쿠폰</p>
                        <button
                            onClick={onClose}
                            className="flex flex-row space-x-2 items-center"
                        >
                            <Icon.X/>
                        </button>
                    </div>

                    {coupons.map((item, index) => (
                        <div key={index}
                             onClick={() => onSelect(item.id)}
                             className="cursor-pointer flex justify-between items-center border-b pb-4"
                        >
                            <div className="">
                                <p className="font-semibold">{item.name}</p>
                                <p className="text-15 text-gray-500">{item.validDateStr}까지</p>
                            </div>
                            <div
                                className={`${
                                   selectedCouponIds.findIndex(i => i === item.id) > -1  ? 'bg-gray-900' : 'bg-gray-300'
                                } rounded-full wh-6 grid place-content-center`}
                            >
                                <Icon.Tick className="text-white stroke-current"/>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};
